import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  CircularProgress,
} from '@material-ui/core';
import { Redirect } from 'react-router';
import { postCreateCategory } from '../../../requests/api/categories';

import useStyles from './styles';

function CategoryCreateForm({
  className,
  supermarkets,
  categories,
  ...rest
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [submitSuccess, setSubmitSuccess] = useState(false);

  if (submitSuccess) {
    return <Redirect to="/config/categories" />;
  }

  return (
    <Formik
      initialValues={{
        name: '',
        supermarket: '',
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().max(255).required('Debe ingresar un nombre'),
        supermarket: Yup.number().required('Debe seleccionar un supermercado').positive().integer(),
      })}
      onSubmit={async (values, {
        setErrors,
        setStatus,
        setSubmitting,
      }) => {
        try {
          // Make API request
          const data = {
            name: values.name,
            supermarket: values.supermarket,
          };

          const response = await postCreateCategory(data);

          if (response.success) {
            setSubmitSuccess(true);
            setStatus({ success: true });
            setSubmitting(false);
            enqueueSnackbar(response.message, {
              variant: 'success',
            });
          } else {
            setStatus({ success: false });
            setErrors({ submit: response.message });
            enqueueSnackbar(response.message, {
              variant: 'warning',
              action: <Button href="/config/categories">Volver atrás</Button>,
            });
          }
        } catch (error) {
          setStatus({ success: false });
          setErrors({ submit: error.message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.root, className)}
          onSubmit={handleSubmit}
          {...rest}
        >
          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label="Nombre"
                    name="name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    value={values.name}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  { supermarkets.length > 0
                    ? <TextField
                        fullWidth
                        label="Supermercado"
                        name="supermarket"
                        onChange={handleChange}
                        select
                        value={values.supermarket}
                        variant="outlined"
                        required
                      >
                        {supermarkets.map((supermarket) => (
                          <MenuItem
                            value={supermarket.id}
                            key={supermarket.id}
                          >
                            {supermarket.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    : <CircularProgress style={{ color: 'var(--brand-blue' }} />
                  }
                </Grid>
              </Grid>
              <Box mt={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Guardar
                </Button>
              </Box>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  );
}

CategoryCreateForm.propTypes = {
  className: PropTypes.string,
  supermarkets: PropTypes.array,
  categories: PropTypes.array,
};

export default CategoryCreateForm;
